
import React from 'react';

import CrmUsersCard from './components/CrmUsersCard';

const Team: React.FC = () => {
    return (
        <div className="space-y-8">
            <CrmUsersCard />
        </div>
    );
};

export default Team;
